module.exports = __webpack_public_path__ + "asset/image-ic_category_15-f42716a4a6fd4b15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/ic_category_15.svg
// module id = D5dL
// module chunks = 0